import { render, staticRenderFns } from "./CompanyOptions.vue?vue&type=template&id=0b52d62b&"
import script from "./CompanyOptions.vue?vue&type=script&lang=js&"
export * from "./CompanyOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports